import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import DeclineQuotationModal from '../decline-quotation-modal/DeclineQuotationModal'
import ConfirmQuotationModal from '../owner-can-confirm-quotation-footer/confirm-quotation-modal/ConfirmQuotationModal'
import OwnerCurrentActionFooterContainer from '../OwnerCurrentActionFooterContainer'
import UploadQuotationModal, {
  IUploadQuotationProps,
} from '../upload-quotation-modal/UploadQuotationModal'
import { CompanyInformationClientProposalFragment } from '../../../../../../../lib/graphql'
import { Button } from '../../../../../../../shadcn/components/ui/button'
import { IProposalInteractionsProps } from '../../../../../../organisms/proposal/Proposal'
import PingPongButton from '../../../../../../organisms/proposal/proposal-cta/buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../../../../organisms/proposal/proposal-cta/utils/ping-pong-button-type.enum.ts'

const OwnerCanUploadQuotationFooter = ({
  clientProposal,
  uploadQuotationData,
  ownerActions,
}: {
  ownerActions: IProposalInteractionsProps['ownerActions']
  uploadQuotationData?: IUploadQuotationProps
  clientProposal: CompanyInformationClientProposalFragment
}) => {
  const [isOpenConfirmQuotationModal, setIsOpenConfirmQuotationModal] =
    useState(false)
  const [isOpenLoadQuotation, setIsOpenLoadQuotation] = useState(false)
  const [isOpenDeclineQuotationModal, setIsOpenDeclineQuotationModal] =
    useState(false)

  const ownerConfirmedQuotation = ownerActions?.ownerConfirmedQuotation
  const ownerUploadedQuotation = ownerActions?.ownerUploadedQuotation
  const ownerDeclinedQuotation = ownerActions?.ownerDeclinedQuotation

  if (
    !ownerConfirmedQuotation ||
    !ownerUploadedQuotation ||
    !ownerDeclinedQuotation
  ) {
    return null
  }

  return (
    <OwnerCurrentActionFooterContainer>
      {clientProposal.clientPricingItems &&
      clientProposal.clientPricingItems.length > 0 ? (
        <PingPongButton
          dataTestId='confirm-quotation-button'
          label={
            <FormattedMessage
              id='ui.OwnerCanUploadQuotationFooter.confirmQuote'
              defaultMessage='Valider le devis'
            />
          }
          type={PingPongButtonTypeEnum.CONFIRM}
          onClick={() => setIsOpenConfirmQuotationModal(true)}
        />
      ) : (
        <Button disabled={true}>Valider le devis</Button>
      )}

      <div className='flex flex-row gap-3'>
        <PingPongButton
          label={
            <FormattedMessage
              id='ui.OwnerCanUploadQuotationFooter.uploadQuote'
              defaultMessage='Charger un devis'
            />
          }
          onClick={() => setIsOpenLoadQuotation(true)}
          type={PingPongButtonTypeEnum.LOAD_QUOTATION}
          className='!px-0'
        />
        <PingPongButton
          type={PingPongButtonTypeEnum.DECLINED_BY_OWNER}
          label={
            <FormattedMessage
              id='ui.OwnerCanUploadQuotationFooter.declineBooking'
              defaultMessage='Refuser la demande'
            />
          }
          onClick={() => setIsOpenDeclineQuotationModal(true)}
          className='!px-0'
        />
      </div>

      {isOpenConfirmQuotationModal && (
        <ConfirmQuotationModal
          isOpen={isOpenConfirmQuotationModal}
          setIsOpen={setIsOpenConfirmQuotationModal}
          clientProposal={clientProposal}
          ownerConfirmedQuotation={ownerConfirmedQuotation}
          uploadQuotationData={uploadQuotationData}
        />
      )}
      {isOpenLoadQuotation && (
        <UploadQuotationModal
          isOpenModal={isOpenLoadQuotation}
          setIsOpenModal={setIsOpenLoadQuotation}
          isModalQuotation={true}
          uploadQuotationData={uploadQuotationData}
          clientProposal={clientProposal}
          ownerUploadedQuotation={ownerUploadedQuotation}
        />
      )}
      {isOpenDeclineQuotationModal && (
        <DeclineQuotationModal
          isOpenModal={isOpenDeclineQuotationModal}
          setIsOpenModal={setIsOpenDeclineQuotationModal}
          ownerDeclinedQuotation={ownerDeclinedQuotation}
        />
      )}
    </OwnerCurrentActionFooterContainer>
  )
}

export default OwnerCanUploadQuotationFooter
